import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CommonValidators } from '../../lib/validators/common.validators';
import { User } from '../model/user.model';

@Component({
    selector: 'app-user-details',
    templateUrl: './user-details.component.html',
    styleUrls: ['./user-details.component.scss'],
    standalone: false
})
export class UserDetailsComponent implements OnChanges {

  userDetailsForm: FormGroup;

  @Input() emailConfirmation: boolean = false;
  @Input() initialUser?: User
  @Output() validated: EventEmitter<User> = new EventEmitter();

  constructor(private formBuilder: FormBuilder) {
    this.userDetailsForm = this.resetForm();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.userDetailsForm = this.resetForm();
  }

  resetForm(): FormGroup {
    return this.formBuilder.group({
      email: [this.initialUser?.email, [Validators.required, Validators.email]],
      emailConfirmation: [{value: null, disabled: !this.emailConfirmation}, [Validators.required, Validators.email]]
    }, {
      validators: this.emailConfirmation ? CommonValidators.equal('email', 'emailConfirmation') : null
    });
  }

  submit() {
    if (this.userDetailsForm?.valid) {
      this.validated.emit({
        uuid: this.initialUser?.uuid,
        name: this.initialUser?.name,
        surname: this.initialUser?.surname,
        role: this.initialUser?.role,
        email: this.userDetailsForm?.get('email')?.value,
        mfaEnabled: this.initialUser?.mfaEnabled ?? false
      })
    }
  }
}
